<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div>
        <el-form :inline="true" :model="searchForm" ref="search" size="small">
          <el-form-item label="商品名称" prop="name">
            <el-input
              style="width: 232px"
              v-model="searchForm.name"
              placeholder="请输入商品名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="平台商品编号" prop="platformGoodsNo">
            <el-input
              style="width: 232px"
              v-model="searchForm.platformGoodsNo"
              placeholder="请输入商品编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品类型" prop="goods_type">
            <el-select
              style="width: 232px"
              v-model="searchForm.goods_type"
              placeholder="请选择商品类型"
              filterable
              clearable
            >
              <el-option
                v-for="item in goods_types"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="verifyStatus">
            <el-select
              style="width: 232px"
              v-model="searchForm.verifyStatus"
              placeholder="请选择状态"
              clearable
            >
              <el-option
                v-for="item in dictionaries.goods_verify_status"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间" prop="applyTime">
            <el-date-picker
              style="width: 232px"
              v-model="applyTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="审核时间" prop="verifyTime">
            <el-date-picker
              style="width: 232px"
              v-model="verifyTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3>列表数据</h3>
      <div class="btn-list">
        <div class="item">
          <el-radio-group v-model="radio1" @change="selectStatus">
            <el-radio-button label="0" border
              >全部({{ countGroupByStatus.totalCount }})</el-radio-button
            >
            <el-radio-button label="1"
              >待审核({{ countGroupByStatus.waitVerify }})</el-radio-button
            >
            <el-radio-button label="3"
              >已通过({{ countGroupByStatus.passVerify }})</el-radio-button
            >
            <el-radio-button label="2"
              >已驳回({{ countGroupByStatus.failVerify }})</el-radio-button
            >
          </el-radio-group>
        </div>
        <div calss="item"></div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
    <!--========================== el-dialog =================================-->
    <el-dialog
      title="温馨提示"
      :visible.sync="isUp"
      width="518px"
      :append-to-body="true"
    >
      <template>
        <div class="info">
          <i class="el-icon-warning" style="color: red; font-size: 16px"></i
          >是否取消申请？
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isUp = false">取消</div>
          <div class="info-s" @click="submit()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script >
import LbTable from '../../../components/lb-table/lb-table'
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import Label from '../components/label.vue'
import ModifyState from '../components/ModifyState.vue'
import mixinsGiftlist from '../mixins/mixinsGiftlist.js'
export default {
  mixins: [mixinsGiftlist],
  components: {
    Label,
    LbTable,
    breadcrumbTop,
    ModifyState,
    breadcrumbSearch
    // BaseList
  },
  data () {
    return {
      verifyTime: [],
      applyTime: [],
      radio1: '0',
      isUp: false,
      searchList: {
        list: [
          { title: '商品审核', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      shopLists: [
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '2',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '2',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '3',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '4',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '4',
          name: 'cdd',
          retailPrice: 36
        },
      ],
      title: '批量上架',
      isShow: false,
      GoodsExportLoading: false,
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品审核', path: '', type: '1' }
        ]
      },
      searchForm: {
        name: '',
        platformGoodsNo: '',
        verifyStatus: '',
        verifyStartTime: '',
        verifyEndTime: '',
        applyStartTime: '',
        applyEndTime: '',
        pageNo: 1,
        pageSize: 10,
        goods_type: null
      },
      currentStatus: 100, // 当前列表状态
      groupByStatus: { // 数据切换
        totalCount: 100, // 全部
        onSaleCount: 200, // 上架中商品
        offSaleCount: 300 // 已下架商品
      },
      countGroupByStatus: { // 商品列表数量统计
        totalCount: 100,
        failVerify: 200,
        waitVerify: 100,
        passVerify: 100,
      },
      // 数据列表
      list: [],
      loading: false,
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      originList: [

      ],//来源列表
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '平台商品编号', prop: 'platformGoodsNo', minWidth: '120' },
        {
          label: '商品图片',
          minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <el-image src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
              </div>
            )
          }
        },
        { label: '商品名称', prop: 'name', minWidth: '220' },
        { label: '商品类目', prop: 'categoryName', minWidth: '120' },
        { label: '商品类型', prop: 'goodsType', minWidth: '120' },
        { label: '零售价格', prop: 'retailPrice', minWidth: '120' },
        { label: '库存', prop: 'stock', minWidth: '120' },
        { label: '审核类型', prop: 'applyTypeLabel', minWidth: '120' },
        {
          label: '状态', prop: 'verifyStatusLabel', minWidth: '120',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.verifyStatusLabel == '待审核') {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:20px"></div>
                <div>{scope.row.verifyStatusLabel}</div>
              </p>
            } else if (scope.row.verifyStatusLabel == '已驳回') {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:20px"></div>
                <div>{scope.row.verifyStatusLabel}</div>
              </p>
            } else if (scope.row.verifyStatusLabel == '已通过') {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:20px"></div>
                <div>{scope.row.verifyStatusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background:  #C0C0CC;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:20px"></div>
                <div>{scope.row.verifyStatusLabel}</div>
              </p>
            }
            return (
              <div> {vv}</div>

              // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
            )
          }
        },
        { label: '申请时间', prop: 'applyTime', minWidth: '200' },
        { label: '审核时间', prop: 'goodsVerifyTime', minWidth: '200' },
        { label: '备注', prop: 'reason', minWidth: '200' },
        {
          label: '操作',
          minWidth: '120',
          fixed: 'right',
          renderHeader: (h, scope) => {
            return (
              <div>
                <span style="float:left;">操作</span>
              </div>
            )
          },
          render: (h, scope) => {
            let dd = ''
            if (scope.row.goodsVerifyStatus == 1) {
              dd = <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.upShop(scope.row.id, 'edit') }}>取消申请</span>
            }
            return (
              <div>
                {dd}
                <span style='color:#2D46EE;cursor:pointer;' onClick={() => { this.toOtherPages('applyShopEdit', scope.row.id, 'edit') }}>查看</span>
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      dictionaries: { // 字典数据
        sale_status: [], // 状态
        goods_type: [] // 商品类型
      },
      goods_types: [
        {
          dictId: '1',
          dictName: '普通商品'
        },
        {
          dictId: '3',
          dictName: '赠品'
        }
      ],
      selectionGoods: [], // 选 中 商品
      parArray: [], // 按钮权限
      goodsId: ''
    }
  },
  mounted () {

  },
  created () {
    // 获取字典值
    this.getDictionaries('goods_type')
    this.getDictionaries('goods_verify_status')
    this.fetchData()
  },
  methods: {
    selectStatus () {
      if (this.radio1 == 0) {
        this.radio1 = ''
      }
      this.searchForm.verifyStatus = this.radio1
      this.fetchData()
    },
    submit () {
      let data = {
        id: this.goodsId
      }
      this.axios.post('/goods/verifyCancel', data).then(res => {
        if (res.code == 0) {
          this.isUp = false
          this.$message({ type: 'success', message: '操作成功!' })
          this.fetchData()
        }
      })
    },
    upShop (val) {
      this.isUp = true
      this.goodsId = val
    },
    add () {
      this.$router.push({
        name: 'addGoodsCategory',
        query: {}
      })
    },
    changeUp (val) {
      this.isUp = val
    },
    //表格合并行和列
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.shopLists.length
      for (let i = 0; i < len; i++) {
        const item = this.shopLists[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.skuNo === this.shopLists[i - 1].skuNo) {
            item.$rows = 0
            this.shopLists[pos].$rows = this.shopLists[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    getretailPrice (title, row) {
      this.dialog.visible = true
      if (title == 'retailPrice') {
        this.dialog.title = '零售价'
      } else if (title == 'stock') {
        this.dialog.title = '可用库存'
      } else {
        this.dialog.title = '销量'
      }
      this.dialog.width = '640px'
      this.dialog.type = title
      this.dialog.list = row.skuList
    },
    fetchData (type) {
      if (type == 'reset') {
        this.searchForm.pageNo = 1
        this.$refs['search'].resetFields()
        this.verifyTime = []
        this.applyTime = []
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
      }
      this.psVerifyPageList()
    },
    psVerifyPageList () {
      this.loading = true
      if (this.applyTime) {
        this.searchForm.applyStartTime = this.applyTime[0]
        this.searchForm.applyEndTime = this.applyTime[1]
      }
      if (this.verifyTime) {
        this.searchForm.verifyStartTime = this.verifyTime[0]
        this.searchForm.verifyEndTime = this.verifyTime[1]
      }
      this.axios.post('/goods/psVerifyPageList', this.searchForm).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach(e => {
            e.marketPrice = Number(e.marketPrice)
            e.stock = Number(e.stock)
            e.soldNum = Number(e.soldNum)
            e.mainImageArr = []
            e.mainImageArr.push(e.mainImage)
            e.skuList.forEach(it => {
              it.skuNo = e.goodsNo + it.skuNo
            })
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.loading = false;
        this.getCountGroupByStatus()// 获取商品列表数量统计
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    getButtonTreeDto () {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'companyCode'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
    },
    // 获取字典数据
    getDictionaries (type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    // 获取商品列表数量统计
    getCountGroupByStatus () {
      this.searchForm.verifyStatus=''
      this.axios.post('/goods/verifyGetCountGroupByStatus', this.searchForm).then((res) => {
        this.countGroupByStatus = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList () {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 品牌 列表
    getBrandList () {
      const params = { pageNo: 1, pageSize: 999 }
      this.$api.brandCommList(params).then((res) => {
        this.brandList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory (val) {
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 切换当前列表
    onChangeList (state) {
      this.page = { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }
      this.currentStatus = state
      // if ( this.currentStatus === this.assignStatus.all) {}
      if (this.currentStatus === this.groupByStatus.totalCount) { this.fetchData('all') }
      if (this.currentStatus === this.groupByStatus.onSaleCount) { this.fetchData('up') }
      if (this.currentStatus === this.groupByStatus.offSaleCount) { this.fetchData('down') }
    },
    // 多选
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    // 上架、下架
    async operationStatus (type, row) {
      this.isShow = true
      if (type == 'up') {
        this.title = '批量上架'
      } else {
        this.title = '批量下架'
      }
      return
      console.log(type, row)
      let msg = type === 'up' ? `是否上架商品, 是否继续?` : `是否下架商品, 是否继续?`
      const params = { ids: [] }
      const selectionId = []
      const titleArr = []
      const selectionGoods = this.selectionGoods
      selectionGoods.forEach(e => { selectionId.push(e.id) })
      if (row) {
        this.dialog.row = row
        params.ids.push(row.id)
        titleArr.push(row.name)
        msg = type === 'up' ? `是否上架【${row.name}】, 是否继续?` : `是否下架【${row.name}】, 是否继续?`
      } else {
        this.list.forEach(e => {
          selectionId.forEach(s => {
            if (e.id === s) {
              titleArr.push(e.name)
            }
          })
        })
        params.ids = selectionId

      }
      // console.log(selectionId.length, type, selectionId)
      if (params.ids.length === 0) { return this.$message({ type: 'error', message: '需要选择商品!' }) }

      if (type === 'up') {
        const findObj = selectionGoods.find(e => { return e.status === 1 })
        if (findObj) { return this.$message({ type: 'error', message: '已有商品上架!' }) }
      }
      if (type === 'down') {
        this.$api.giftListByGoodId(params.ids).then((res) => {
          if (res.data.length > 0) {
            this.giftListByGoodId = res.data
            return this.showModifyState(type, titleArr)
          } else {
            return this.onUpDownOperation(type, params, msg)
          }
        }).catch((err) => {
          // console.log(err)
        })
        // setTimeout(() => {}, 1000)
        const findObj = selectionGoods.find(e => { return e.status === 0 })
        // if (findObj) { return this.$message({ type: 'error', message: '已有商品下架!' }) }
      } else {
        this.onUpDownOperation(type, params, msg)
      }
    },
    onUpDownOperation (type, params, msg) {
      let operationFun
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        switch (type) {
          case 'up':
            operationFun = this.$api.goodsPutOn
            // this.column = columnConsumption
            break
          // 分配记录
          case 'down':
            operationFun = this.$api.goodsPutOff
            break
          // default:
        }
        operationFun(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    showModifyState (skuList, titleArr) {
      // console.log('showModifyState', skuList, titleArr)
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '下架提示'
      this.dialog.width = '640px'
      this.dialog.type = 'modifyState'
      // this.dialog.row = row
      this.dialog.titleArr = titleArr
      // this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 根据商品id,获取礼包列表查询接口
    onGiftListByGoodId (ids) {
      // const params = { goodsIds: ids }
      this.$api.giftListByGoodId(ids).then((res) => {
        console.log(res)
        return res
      }).catch((err) => {
        // console.log(err)
        return res
      })
    },
    // 删除商品
    onGoodsDelete (row) {
      const msg = `此操作将删除【${row.name}】, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '删除商品',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsDelete(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    toOtherPages (name, parameter, type) {
      this.$router.push({
        name,
        query: { id: parameter, type }
      })
    },
    // 获取 商品 KSU
    getGoodCopySku (skuList, row) {
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '复制SKU码'
      this.dialog.width = '640px'
      this.dialog.type = 'skuList'
      this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 复制 KSU
    onCopySku (info) {
      // console.log('onCopySku', info)
      const t = this
      this.$copyText(info).then(
        function (e) {
          t.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          t.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    // 商品导出
    onGoodsExport () {
      this.GoodsExportLoading = true
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        status: this.currentTab
      }
      params = Object.assign(params, this.searchForm)
      // 类目id
      const tempCategoryIdArr = [].concat(params.categoryId)
      if (tempCategoryIdArr && tempCategoryIdArr.length !== 0) {
        params.categoryId = tempCategoryIdArr[tempCategoryIdArr.length - 1]
      }
      for (const item in params) {
        if (typeof params[item] === 'string') {
          params[item] = params[item].trim()
          if (params[item] === '') { delete params[item] }
        }
      }
      this.$api.goodsExport(params).then((res) => {
        this.GoodsExportLoading = false
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
        console.log(err)
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/styles/modifyState.scss";
::v-deep.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    white-space: normal;
  }
  .el-dialog__header {
    text-align: left;
    border-bottom: none;
  }
  .info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #303033;
    opacity: 1;
    text-align: left;
  }
  .info-b {
    margin-left: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 40px;
    color: #303033;
    text-align: left;
  }
  .info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
  }
  .info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}

::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}
.dialog-search {
  margin-top: 4px;
}
.dialog-button {
  margin-top: 6px;
}
.dialog-pagination {
  margin-top: 20px;
  margin-bottom: 20px;
  float: right;
}
.platform {
  margin: 20px 20px;
  .el-radio {
    padding: 10px 10px;
  }
}
/deep/.hide-content {
  display: none !important;
}
//删除全页面按钮边框
// .el-button {
//   border: none;
// }
// 按钮
.btn-list {
  margin-bottom: 22px;
  display: flex;
  .item {
    flex: 1;
    &:last-child {
      text-align: right;

      .el-button {
        width: 120px;
        // color: #2d7edf;
        // border: 1px solid #2d7edf;
        &:last-child,
        .goods-export {
          color: #ffffff;
          // border: 1px solid #409eff;
        }
      }
      .goods-export {
        color: #ffffff;
        // border: 1px solid #409eff;
      }
    }
    .el-button {
      height: 36px;
      line-height: 36px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .is-disabled {
      background-color: #f4f4f5 !important;
      border: 1px solid #d3d4d6 !important;
      color: #909399 !important;
    }
  }
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
/deep/.el-scrollbar {
  height: 10px;
}
/deep/.el-scrollbar__bar.is-horizontal {
  height: 9px;
}

:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
</style>
